import React, { FC } from 'react';
import { Box } from '@material-ui/core';
import { useShopConfig } from '../../hooks/shopConfig';
import TypographyWrapper, { TypographyFormat } from '../TypographyWrapper/TypographyWrapper';
import { LanguageSwitcher } from '../LanguageSwitcher/LanguageSwitcher';
import ExternalLink from '../ExternalLink/ExternalLink';
import css from './MainSiteBanner.module.css';
import { useWeglot } from '../../hooks/useWeglot';
import { useDefaultShopStyles } from '../../hooks/useDefaultShopStyles';

const MainSiteBanner: FC = () => {
  const { shopName, mainSite } = useShopConfig();
  const defaultShopStyles = useDefaultShopStyles();
  const bannerColor = defaultShopStyles.shopColor10 || 'white';

  if (!mainSite) {
    return null;
  }
  const isWeglotEnabled = !!useWeglot().weglot;

  return (
    <Box bgcolor={bannerColor} className={css.mainSiteBanner}>
      <div className={css.content}>
        {isWeglotEnabled && (
          <div className={css.languageSwitcher}>
            <LanguageSwitcher />
          </div>
        )}
        <ExternalLink
          href={mainSite}
          className={css.externalLink}
          // Allow brands to collect opener and referrer data when going back to the main site
          rel={{ noOpener: false, noReferrer: false }}
        >
          <TypographyWrapper
            variant="subtitle1"
            format={TypographyFormat.Underlined}
            typographyOverrides={{
              style: {
                minWidth: 0,
                overflow: 'hidden',
                whiteSpace: 'nowrap',
                textOverflow: 'ellipsis',
              },
            }}
            disableLinkify
          >
            {shopName} Main Site
          </TypographyWrapper>
        </ExternalLink>
      </div>
    </Box>
  );
};

export default MainSiteBanner;
